import { Pipe, PipeTransform } from '@angular/core';
import { format } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import { DateFormat } from '../enum';

/**
 * Format a given date. If timeZoneId is provided the time will be converted to it and append it's abbreviation
 * e.g. 01/07/2019 10:24 AM CST
 */
@Pipe({
    name: 'floDateTimeZone',
})
export class DateTimeZonePipe implements PipeTransform {
    public transform(value: Date, timeZoneId: string, momentFormat: string = 'dt'): any {
        if (value) {
            const date: Date = value;

            momentFormat = momentFormat || 'dt';
            let formatString: string = '';

            if (momentFormat === 'dt') {
                formatString = DateFormat.MDYhma;
            } else if (momentFormat === 'd') {
                formatString = DateFormat.MMDDYYYY;
            } else {
                formatString = momentFormat;
            }

            if (timeZoneId) {
                if (momentFormat !== 'd') {
                    formatString += ' z';
                }

                return formatInTimeZone(date, timeZoneId, formatString);
            }
            return format(date, formatString);
        }

        return null;
    }
}
